import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../Invoice/SalesInvoice.css";
import Invoice from "../../../../../assets/Image/invoice1.png"
import User from "../../../../../assets/Image/user01.png"
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../../utils/secure-route/AuthContext";
import { ToastContainer } from "react-toastify";
import useSwal from '../../../../common/ReusableComponent/useSwal'
import SalesInvoicePrint from "./SalesInvoicePrint";
import { capitalizeFirstLetter } from "../../../../../utils/helper/common";
import { useToastHandler } from "../../../../common/ToastHandler";
import CustomDateInput from "../../../../../context/CustomDateInput";
import useFormattingUtils from "../../../../../context/useFormattingUtils";
import { useShift } from "../../Lottery/ShiftContext";
function SalesInvoice() {
  const [, setActiveButton] = useState("");
  const [productInventory, setProductInventory] = useState([]);
  const [, setSalesInvoiceData] = useState([]);
  const [showInvoice, setShowInvoice] = useState(false);
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const [roundOffEnabled, setRoundOffEnabled] = useState(false);
  const { handleToast } = useToastHandler()
  const handleCloseModal = () => setShowInvoice(false);
  const [modalData, setModalData] = useState(null);
  const [additionalDiscount, setAdditionalDiscount] = useState("0");
  const [, setRoundOffAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const { confirmDelete } = useSwal()
  const [searchQuery, setSearchQuery] = useState("");
  const [focusedIndex, setFocusedIndex] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [floatingDropdownStyle, setFloatingDropdownStyle] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [productDetailsCache, setProductDetailsCache] = useState({});
  const [isSearching, setIsSearching] = useState(false);
  const handleAdditionalDiscountChange = (e) => {
    let value = e.target.value;

    if (!/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    let numericValue = parseFloat(value);

    if (numericValue >= totalAmount) {

      handleToast({
        type: 'INFO',
        message: 'Additional discount must be less than the total amount.'
      })

      setAdditionalDiscount("0");
      setFormData((prevFormData) => ({
        ...prevFormData,
        additional_discount_value: "0",
      }));
      return;
    }

    setAdditionalDiscount(value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      additional_discount_value: value,
    }));
  };

  const [products, setProducts] = useState([
    {
      store: storeId,
      barcode: "",
      segment_barcode: "",
        segment_id: "",
      additional_discount_value: "0",
      title: "",
      qty: 0,
      discount: "",
      discount_percentage: "",
      rate: 0,
      selling_price: "",
      uom: "",
      amount: 0,
      total: 0,
      sold_qty_stock: 0,
      product_inventory: "",
      roundOff: 0,
    },
  ]);
  const [formData, setFormData] = useState({
    store: storeId,
    barcode: "",
    sr_no: "",
    date: new Date().toISOString().split("T")[0],
    transaction_type: "Sales Invoice",
    invoice_no: "",
    customer: "",
    additional_discount_value: "0",
    bank: "",
    amount: "",
    cash_amount: "",
    cheque_amount: "",
    cheque_no: "",
    total_amount: "",
    pay_method_status: "pay_now",
    pay_method: "cash",
    note: "",
    atm_commission: "",
    income_type: null,
    bank_deposite_type: null,
    owner: null,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const { Delete, Post, _Get, refreshCache, getAPI, Get } = useApi();
  const { formatCurrency } = useFormattingUtils();
  const { shiftData, startShift } = useShift();
  const [showShiftRequiredModal, setShowShiftRequiredModal] = useState(false);
  const [startingShiftForSale, setStartingShiftForSale] = useState(false);
  const [pendingSubmitOpenModal, setPendingSubmitOpenModal] = useState(false);
  const [terminals, setTerminals] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState(null);
  const [showTerminalModal, setShowTerminalModal] = useState(false);
  const [terminalStatus, setTerminalStatus] = useState("IDLE");
  const [terminalMessage, setTerminalMessage] = useState("");
  const pollingRef = React.useRef(null);

  useEffect(() => {
    if (storeId) {
      Get(`${getAPI('paymentTerminals')}?store_id=${storeId}`)
        .then((data) => {
          setTerminals(data || []);
          if (data && data.length > 0) {
            const def = data.find((t) => t.is_default) || data[0];
            setSelectedTerminal(def);
          }
        })
        .catch((err) => console.error("Error fetching terminals:", err));

      Get(`${getAPI('configurationForStore')}?store=${storeId}`)
        .then((res) => {
          const cfg = res?.results?.[0] || res?.data?.[0] || res?.[0] || res;
          if (cfg && cfg.default_pay_method) {
            setFormData(prev => ({ ...prev, pay_method: cfg.default_pay_method }));
          }
        })
        .catch((err) => console.error("Error fetching store config:", err));
    }
  }, [storeId]);

  useEffect(() => {
    if (storeId) {
      setProducts((prevProducts) =>
        prevProducts.map(
          (product) =>
            product.store ? product : { ...product, store: storeId }
        )
      );
      setFormData((prevFormData) => ({ ...prevFormData, store: storeId }));
    }
  }, [storeId]);

  const handleCancel = () => {

    setFormData({
      store: storeId,
      barcode: "",
      sr_no: "",
      invoice_no: "",
      customer: "",
      date: new Date().toISOString().split("T")[0],
      transaction_type: "Sales Invoice",
      customer_name: "",
      additional_discount_value: "0",
      bank: "",
      amount: "",
      cash_amount: "",
      cheque_amount: "",
      cheque_no: "",
      total_amount: "",
      pay_method_status: "pay_now",
      pay_method: "cash",
      note: "",
      atm_commission: "",
      income_type: null,
      bank_deposite_type: null,
      owner: null,
    });

    setProducts([
      {
        store: storeId,
        segment_barcode: "",
        segment_id: "",
        barcode: "",
        customer: "",
        additional_discount_value: "0",
        title: "",
        qty: 0,
        discount: "",
        discount_percentage: "",
        selling_price: "",
        rate: 0,
        uom: "",
        amount: 0,
        total: 0,
        sold_qty_stock: 0,
        product_inventory: "",
        roundOff: 0,
      },
    ]);
  };

  const columns = [
    { field: "invoice_no", header: "Invoice No" },
    { field: "customer", header: "Customer Name" },
    { field: "final_after_discount", header: "Amount" },
    { field: "pay_method", header: "Payment Type" },
    { field: "date", header: " Invoice Date" },
  ];

  useEffect(() => {
    setActiveButton(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    fetchProductInventory(1);
  }, []);

  const handleLinkClick = (path) => {
    setActiveButton(path);
    navigate(path);
  };

  const handleDeleteRow = (indexToRemove) => {
    if (indexToRemove !== products.length - 1) {
      const updatedProducts = products.filter(
        (_, index) => index !== indexToRemove
      );

      if (updatedProducts.length === 0) {

        setProducts([
          {
            segment_barcode: "",
        segment_id: "",
            barcode: "",
            customer: "",
            additional_discount_value: "0",
            title: "",
            qty: 0,
            discount: "",
            discount_percentage: "",
            selling_price: "",
            rate: 0,
            uom: "",
            amount: 0,
            total: 0,
            sold_qty_stock: 0,
            product_inventory: "",
            roundOff: 0,
          },
        ]);
      } else {
        setProducts(updatedProducts);
      }
    }
  };

  const getAvailableSegments = (product) => {
    if (!product || !Array.isArray(product.segments)) return [];

    return product.segments.filter((segment) => {
      const hasStock =
        Number(segment?.remaining_inventory || 0) > 0 ||
        Number(product?.current_stock || 0) > 0 ||
        Number(product?.total_current_stock || 0) > 0;

      return segment?.inventory_available === true && hasStock;
    });
  };

  const getDefaultAvailableSegment = (product) => {
    const availableSegments = getAvailableSegments(product);

    if (availableSegments.length > 0) {
      /**
       * Important:
       * Do not use product.segments[0].
       * Example: Mattel UNO has old Box segment first, but available Quintal segment second.
       * So select first available segment instead.
       */
      return availableSegments[0];
    }

    return null;
  };

  const getProductFromCacheOrInventory = (productId) => {
    if (!productId) return null;

    return (
      productInventory.find((item) => item.id === productId) ||
      searchResults.find((item) => item.id === productId) ||
      productDetailsCache[productId] ||
      null
    );
  };

  const getSegmentByIdOrUom = (product, selectedUom, selectedSegmentId = "") => {
    if (!product || !Array.isArray(product.segments)) return null;

    const availableSegments = getAvailableSegments(product);

    if (selectedSegmentId) {
      const matchedById = availableSegments.find(
        (segment) => segment.id === selectedSegmentId
      );

      if (matchedById) return matchedById;
    }

    if (selectedUom) {
      const matchedByUom = availableSegments.find(
        (segment) => segment.uom === selectedUom
      );

      if (matchedByUom) return matchedByUom;
    }

    return getDefaultAvailableSegment(product);
  };

  const buildProductRowFromSegment = ({
    existingRow,
    selectedProduct,
    selectedSegment,
    qty = 1,
  }) => {
    const sellingPrice = parseFloat(selectedSegment?.selling_price) || 0;
    const totalPcInUom = parseInt(selectedSegment?.total_pc_in_uom, 10) || 0;
    const discountPercentage =
      parseFloat(existingRow?.discount_percentage || selectedProduct?.discount_percentage) || 0;

    const amount = sellingPrice * qty;
    const total = amount - (amount * discountPercentage) / 100;

    return {
      ...existingRow,
      store: storeId,
      title: selectedProduct?.title || "",
      product: selectedProduct?.id || "",
      barcode: selectedProduct?.barcode || "",
      segment_barcode: selectedSegment?.segment_barcode || "",
      segment_id: selectedSegment?.id || "",
      selling_price: sellingPrice,
      rate: sellingPrice,
      uom: selectedSegment?.uom || "",
      qty,
      sold_qty_stock: qty,
      amount,
      total,
      total_pc_in_uom: totalPcInUom,
      discount: existingRow?.discount || "",
      discount_percentage: discountPercentage,
      additional_discount_value: "0",
      product_inventory: selectedProduct?.id || "",
      roundOff: 0,
      error: "",
    };
  };

  const handleInputChange = (index, field, value) => {
    const updatedProducts = [...products];

    if (field === "barcode") {
      if (value.match(/^\d{4,}$/)) {

        updatedProducts[index].segment_barcode = value;
        updatedProducts[index].barcode = "";
      } else {
        updatedProducts[index].barcode = value;
        updatedProducts[index].segment_barcode = "";
      }
    } else {
      updatedProducts[index][field] = value;
    }

    const parsedValue = parseFloat(value) || 0;

    if (field === "qty") {
      updatedProducts[index].qty = parsedValue;
      updatedProducts[index].sold_qty_stock = parsedValue;
    } else if (field === "discount") {
      updatedProducts[index].discount_percentage = parsedValue;
    }

    if (field === "selling_price") {
      updatedProducts[index].selling_price = parsedValue;
    }

    if (field === "uom") {
      const selectedProduct = getProductFromCacheOrInventory(
        updatedProducts[index].product
      );

      const selectedSegment = getSegmentByIdOrUom(selectedProduct, value);

      if (selectedSegment) {
        updatedProducts[index].segment_id = selectedSegment.id || "";
        updatedProducts[index].segment_barcode =
          selectedSegment.segment_barcode || "";
        updatedProducts[index].barcode = selectedProduct?.barcode || "";
        updatedProducts[index].selling_price =
          parseFloat(selectedSegment.selling_price) || 0;
        updatedProducts[index].rate =
          parseFloat(selectedSegment.selling_price) || 0;
        updatedProducts[index].total_pc_in_uom =
          parseInt(selectedSegment.total_pc_in_uom, 10) || 0;
      } else {
        updatedProducts[index].segment_id = "";
        updatedProducts[index].segment_barcode = "";
        updatedProducts[index].total_pc_in_uom = 0;
      }
    }

    const selling_price = parseFloat(updatedProducts[index].selling_price) || 0;
    const qty = updatedProducts[index].qty;
    const discount =
      parseFloat(updatedProducts[index].discount_percentage) || 0;
    const amount = selling_price * qty;
    const total = amount - (amount * discount) / 100;

    updatedProducts[index].amount = amount;
    updatedProducts[index].total = total;

    setProducts(updatedProducts);
  };

  const handleBarcodeBlur = async (index) => {
    const updatedProducts = [...products];
    const { barcode, segment_barcode } = updatedProducts[index];

    if (!barcode?.trim() && !segment_barcode?.trim()) {
      updatedProducts[index].error =
        "Please provide a valid barcode or segment barcode.";
      setProducts(updatedProducts);
      return;
    }

    try {
      let foundProduct = null;
      let matchingSegment = null;
      const searchValue = barcode?.trim() || segment_barcode?.trim();

      let apiUrl = `${getAPI("getProductAndInventory")}?page=1&search=${encodeURIComponent(searchValue)}`;

      while (apiUrl && !foundProduct) {
        const response = await Post(apiUrl, {});
        const productList = response?.data?.results || [];

        for (const product of productList) {
          if (product.barcode === searchValue) {
            const availableSegment = getDefaultAvailableSegment(product);

            if (availableSegment) {
              foundProduct = product;
              matchingSegment = availableSegment;
              break;
            }
          }

          if (!foundProduct && product.segments) {
            const segmentMatch = getAvailableSegments(product).find(
              segment => segment.segment_barcode === searchValue
            );

            if (segmentMatch) {
              foundProduct = product;
              matchingSegment = segmentMatch;
              break;
            }
          }
        }

        apiUrl = foundProduct ? null : response?.data?.next;
      }

      if (!foundProduct || !matchingSegment) {
        handleToast({
          type: "ERROR",
          message: "No available stock/UOM found for the given barcode"
        });

        updatedProducts[index].barcode = "";
        updatedProducts[index].segment_barcode = "";
        updatedProducts[index].error = "";
        setProducts(updatedProducts);
        return;
      }

      if (!matchingSegment.inventory_available) {
        handleToast({
          type: "ERROR",
          message: `Product "${foundProduct.title}" is out of stock.`
        });

        updatedProducts[index].barcode = "";
        updatedProducts[index].segment_barcode = "";
        updatedProducts[index].error = "";
        setProducts(updatedProducts);
        return;
      }

      setProductDetailsCache(prev => ({
        ...prev,
        [foundProduct.id]: foundProduct
      }));

      setProductInventory(prev => {
        const exists = prev.some(item => item.id === foundProduct.id);
        if (!exists) {
          return [...prev, foundProduct];
        }
        return prev;
      });

      const currentProduct = updatedProducts[index];
      const isExistingProductRow = currentProduct.product && currentProduct.product !== "";

      const existingProductIndex = products.findIndex(
        (product, idx) =>
          idx !== index &&
          ((barcode?.trim() && product.barcode === barcode.trim()) ||
            (segment_barcode?.trim() && product.segment_barcode === segment_barcode.trim()))
      );

      if (existingProductIndex !== -1) {
        const existingProduct = updatedProducts[existingProductIndex];
        existingProduct.qty += 1;
        const amount = existingProduct.selling_price * existingProduct.qty;
        const total = amount - (amount * (existingProduct.discount_percentage || 0)) / 100;

        existingProduct.amount = amount;
        existingProduct.total = total;

        if (!isExistingProductRow) {
          updatedProducts[index] = {
            store: storeId,
            title: "",
            barcode: "",
            segment_barcode: "",
        segment_id: "",
            product: "",
            rate: 0,
            uom: "",
            qty: 0,
            discount: "",
            discount_percentage: "",
            amount: 0,
            total: 0,
            roundOff: 0,
            error: "",
            selling_price: "",
            sold_qty_stock: 0,
            product_inventory: "",
            additional_discount_value: "0",
            total_pc_in_uom: 0,
          };
        } else {
          updatedProducts[index].barcode = "";
          updatedProducts[index].segment_barcode = "";
          updatedProducts[index].error = "";
        }

        setProducts(updatedProducts);

        handleToast({
          type: 'SUCCESS',
          message: `Quantity updated for "${foundProduct.title}"!`
        });

        return;
      }

      const defaultUom = matchingSegment?.uom || "";
      const defaultSellingPrice = parseFloat(matchingSegment?.selling_price) || 0;
      const totalPcInUom = parseInt(matchingSegment?.total_pc_in_uom, 10) || 0;

      const selectedQty = isExistingProductRow ? updatedProducts[index].qty : 1;

      updatedProducts[index] = buildProductRowFromSegment({
        existingRow: {
          ...updatedProducts[index],
          discount: "",
          discount_percentage: foundProduct.discount_percentage || 0,
        },
        selectedProduct: foundProduct,
        selectedSegment: matchingSegment,
        qty: selectedQty,
      });

      if (index === updatedProducts.length - 1 && !isExistingProductRow) {
        updatedProducts.push({
          store: storeId,
          title: "",
          barcode: "",
          segment_barcode: "",
        segment_id: "",
          product: "",
          rate: 0,
          uom: "",
          qty: 0,
          discount: "",
          discount_percentage: "",
          amount: 0,
          total: 0,
          roundOff: 0,
          error: "",
          selling_price: "",
          sold_qty_stock: 0,
          product_inventory: "",
          additional_discount_value: "0",
          total_pc_in_uom: 0,
        });
      }

      setProducts(updatedProducts);

      handleToast({
        type: 'SUCCESS',
        message: `Product "${foundProduct.title}" ${isExistingProductRow ? 'updated' : 'added'} successfully.`
      });

    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);

      updatedProducts[index].barcode = "";
      updatedProducts[index].segment_barcode = "";
      updatedProducts[index].error = "";
      setProducts(updatedProducts);

      handleToast({
        type: "ERROR",
        message: "Failed to fetch product details. Please check the barcode."
      });
    }
  };

  const handleUomChange = (index, selectedUom, selectedSegmentId = "") => {
    const updatedProducts = [...products];
    const currentRow = updatedProducts[index];

    const selectedProduct = getProductFromCacheOrInventory(currentRow.product);
    const selectedSegment = getSegmentByIdOrUom(
      selectedProduct,
      selectedUom,
      selectedSegmentId
    );

    if (selectedProduct && selectedSegment) {
      const qty = parseFloat(currentRow.qty) || 0;

      updatedProducts[index] = buildProductRowFromSegment({
        existingRow: currentRow,
        selectedProduct,
        selectedSegment,
        qty,
      });
    } else {
      console.warn(`Product with ID ${currentRow.product} or selected UOM not found`);
      updatedProducts[index] = {
        ...currentRow,
        uom: "",
        segment_id: "",
        segment_barcode: "",
        selling_price: 0,
        rate: 0,
        amount: 0,
        total: 0,
        total_pc_in_uom: 0,
      };
    }

    setProducts(updatedProducts);

    handleToast({
      type: 'SUCCESS',
      message: `UOM updated successfully. Rate and totals recalculated.`
    });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleRoundOffChange = (e) => {
    setRoundOffEnabled(e.target.value === "yes");
  };

  const calculateRoundOff = (totalDiscounted) => {
    const decimalPart = totalDiscounted - Math.floor(totalDiscounted);
    const roundedValue =
      decimalPart >= 0.5
        ? Math.ceil(totalDiscounted)
        : Math.floor(totalDiscounted);
    const roundOff = parseFloat((roundedValue - totalDiscounted).toFixed(2));

    return { roundedValue, roundOff };
  };

  const calculateTotals = (products) => {
    let totalQty = 0;
    let totalAmount = 0;
    let totalDiscounted = 0;
    let totalDiscount = 0;
    let totalRate = 0;
    const uniquePer = new Set();
    let discountRowCount = 0;

    products.forEach((product) => {
      totalQty += parseFloat(product.qty) || 0;
      totalAmount += parseFloat(product.amount) || 0;
      totalDiscounted += parseFloat(product.total) || 0;
      totalRate += parseFloat(product.selling_price) || 0;

      if (
        product.discount !== undefined &&
        !isNaN(parseFloat(product.discount))
      ) {
        totalDiscount += parseFloat(product.discount) || 0;
        discountRowCount++;
      }

      if (product.per) {
        uniquePer.add(product.per);
      }
    });

    totalDiscount = discountRowCount > 0 ? totalDiscount / discountRowCount : 0;

    const { roundedValue, roundOff } = calculateRoundOff(totalDiscounted);

    return {
      totalQty,
      totalAmount,
      totalDiscounted,
      totalDiscount,
      totalRate,
      uniquePer: Array.from(uniquePer),
      roundedValue,
      roundOff,
    };
  };

  const totals = calculateTotals(products);
  const {
    totalQty,
    totalAmount,
    totalDiscounted,
    totalDiscount,
    totalRate,
    uniquePer,
    // roundedValue,
    // roundOff,
  } = totals;

  const netAmount = totalDiscounted - parseFloat(additionalDiscount || "0");
  const { roundedValue, roundOff } = calculateRoundOff(netAmount);

  const finalPayableAmount = roundOffEnabled
    ? roundedValue
    : netAmount;


  const debounceRef = useRef(null);
  const dropdownInteractingRef = useRef(false);

  const fetchSalesInvoiceData = async () => {
    setLoading(true);

    _Get("salesInvoiceData")
      .then((response) => {
        const wholesaleInvoices = response.results.filter(
          invoice => invoice.invoice_type === "wholesale"
        );
        setSalesInvoiceData(wholesaleInvoices);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching sales invoice data: ", error);
      })

  };

  const fetchProductInventory = async (page = 1, searchTerm = "") => {
    try {
      setLoading(true);

      let apiUrl = `${getAPI("getProductAndInventory")}?page=${page}`;

      if (searchTerm.trim()) {
        apiUrl = `${getAPI("getProductAndInventory")}?search=${encodeURIComponent(searchTerm)}`;

      }

      const response = await Post(apiUrl);

      if (response?.data?.results) {
        const products = response.data.results;

        if (products.length === 0 && page > 1 && !searchTerm) {
          setCurrentPage(1);
          return fetchProductInventory(1);
        }
        const validProducts = products.filter(item =>
          item.segments?.some(segment => segment.inventory_available)
        );


        if (products.length > 0) {
          const nextInvoiceNo = products[0].next_invoice_no;
          const currentDate = new Date().toISOString().split("T")[0];

          setFormData(prev => ({
            ...prev,
            invoice_no: nextInvoiceNo,
            note: `Date: ${currentDate}, Invoice No: ${nextInvoiceNo}`,
          }));
        }
        const seenTitles = new Set();
        const uniqueProducts = validProducts.filter(item => {
          if (seenTitles.has(item.title)) {
            return false;
          }
          seenTitles.add(item.title);
          return true;
        });

        if (isSearching || searchTerm) {
          setSearchResults(uniqueProducts);
        } else {
          setProductInventory(uniqueProducts);

        }

        setTotalCount(response.data.count || 0);
        setCurrentPage(page);
      } else {
        console.error("Unexpected API response:", response);
        if (isSearching || searchTerm) {
          setSearchResults([]);
        }
      }
    } catch (error) {
      console.error("Inventory fetch error:", error);
      if (error?.response?.data?.detail === "Invalid page." && page > 1) {
        setCurrentPage(1);
        fetchProductInventory(1, searchTerm);
      }
      if (isSearching || searchTerm) {
        setSearchResults([]);
      }
    } finally {
      setLoading(false);
    }
  };

  const updateFloatingDropdownPosition = (element) => {
    if (!element) return;

    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const dropdownWidth = Math.min(420, Math.max(320, rect.width + 160));
    const left = Math.min(Math.max(12, rect.left), viewportWidth - dropdownWidth - 12);

    setFloatingDropdownStyle({
      top: rect.bottom + 8,
      left,
      width: dropdownWidth,
    });
  };

  const closeFloatingDropdown = () => {
    setFloatingDropdownStyle(null);
  };

  useEffect(() => {
    if (focusedIndex === null) return;

    const handleWindowResize = () => {
      closeFloatingDropdown();
      setFocusedIndex(null);
      setSearchResults([]);
      setSearchQuery("");
      setIsSearching(false);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [focusedIndex]);

  const handleSelectProduct = (index, selectedProduct) => {

    setProductDetailsCache(prev => ({
      ...prev,
      [selectedProduct.id]: selectedProduct
    }));

    const existingProductIndex = products.findIndex(
      (product, idx) =>
        idx !== index &&
        product.product === selectedProduct.id
    );

    if (existingProductIndex !== -1) {

      const updatedProducts = [...products];
      const existingProduct = updatedProducts[existingProductIndex];
      existingProduct.qty += 1;
      existingProduct.sold_qty_stock = existingProduct.qty;

      const amount = existingProduct.selling_price * existingProduct.qty;
      const total = amount - (amount * (existingProduct.discount_percentage || 0)) / 100;

      existingProduct.amount = amount;
      existingProduct.total = total;

      if (!updatedProducts[index].product) {
        updatedProducts[index] = {
          store: storeId,
          title: "",
          barcode: "",
          segment_barcode: "",
        segment_id: "",
          product: "",
          rate: 0,
          selling_price: "",
          uom: "",
          qty: 0,
          discount: "",
          discount_percentage: "",
          amount: 0,
          total: 0,
          sold_qty_stock: 0,
          product_inventory: "",
          roundOff: 0,
          error: "",
          additional_discount_value: "0",
          total_pc_in_uom: 0,
        };
      }

      setProducts(updatedProducts);

      handleToast({
        type: 'SUCCESS',
        message: `Quantity updated for "${selectedProduct.title}"!`
      });

      setSearchResults([]);
      setSearchQuery("");
      setFocusedIndex(null);
      setIsSearching(false);
      closeFloatingDropdown();

      return;
    }

    const updatedProducts = [...products];

    const defaultSegment = getDefaultAvailableSegment(selectedProduct);

    if (!defaultSegment) {
      handleToast({
        type: 'ERROR',
        message: `No available UOM/stock found for "${selectedProduct.title}".`
      });
      return;
    }

    updatedProducts[index] = buildProductRowFromSegment({
      existingRow: {
        ...updatedProducts[index],
        discount: "",
        discount_percentage: selectedProduct.discount_percentage || 0,
      },
      selectedProduct,
      selectedSegment: defaultSegment,
      qty: 1,
    });

    if (index === updatedProducts.length - 1) {
      updatedProducts.push({
        store: storeId,
        title: "",
        barcode: "",
        segment_barcode: "",
        segment_id: "",
        product: "",
        rate: 0,
        selling_price: "",
        uom: "",
        qty: 0,
        discount: "",
        discount_percentage: "",
        amount: 0,
        total: 0,
        sold_qty_stock: 0,
        product_inventory: "",
        roundOff: 0,
        error: "",
        additional_discount_value: "0",
        total_pc_in_uom: 0,
      });
    }

    setProducts(updatedProducts);

    setSearchResults([]);
    setSearchQuery("");
    setFocusedIndex(null);
    setIsSearching(false);
    closeFloatingDropdown();

    handleToast({
      type: 'SUCCESS',
      message: `Product "${selectedProduct.title}" added successfully.`
    });
  };

  const handleSearch = (index, query, inputElement = null) => {
    setSearchQuery(query);
    setFocusedIndex(index);

    if (inputElement) {
      updateFloatingDropdownPosition(inputElement);
    }

    if (!query.trim()) {
      setIsSearching(false);
      setSearchResults(productInventory);
      return;
    }

    setIsSearching(true);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchProductInventory(1, query.trim());
    }, 300);
  };

  const triggerCashDrawerPop = async () => {
    try {
      const drawers = await Get(`${getAPI('posCashDrawers')}?store_id=${storeId}`);
      const defaultDrawer = drawers?.find(d => d.is_default || d.enabled) || drawers?.[0];
      if (!defaultDrawer) return;

      if (defaultDrawer.connection_type === "PRINTER_DRIVEN" && defaultDrawer.printer_id) {
        const printers = await Get(`${getAPI('posPrinters')}?store_id=${storeId}`);
        const linkedPrinter = printers?.find(p => p.id === defaultDrawer.printer_id);
        if (linkedPrinter && linkedPrinter.connection_type === "NETWORK") {
          const kickUrl = `http://${linkedPrinter.ip_address}:${linkedPrinter.port || 9100}/kick-drawer`;
          await fetch(kickUrl, { method: "POST", mode: "no-cors" });
        }
      } else if (defaultDrawer.connection_type === "SERIAL" || defaultDrawer.connection_type === "USB") {
        if (defaultDrawer.ip_address) {
          const kickUrl = `http://${defaultDrawer.ip_address}:${defaultDrawer.port || 9100}/kick-drawer`;
          await fetch(kickUrl, { method: "POST", mode: "no-cors" });
        }
      }
    } catch (err) {
      console.warn("Auto drawer kick failed:", err);
    }
  };

  const pollTerminalPayment = (paymentId, payload, openModal) => {
    let attempts = 0;
    if (pollingRef.current) clearInterval(pollingRef.current);
    
    pollingRef.current = setInterval(() => {
      attempts += 1;
      if (attempts > 60) {
        clearInterval(pollingRef.current);
        setTerminalStatus("FAILED");
        setTerminalMessage("Payment timeout. Please try again.");
        return;
      }

      Get(`${getAPI('paymentsTerminal')}${paymentId}/`)
        .then((response) => {
          const status = response.status;
          setTerminalStatus(status);
          if (status === "WAITING_FOR_CUSTOMER") {
            setTerminalMessage(`Please tap, insert, or swipe your card on ${selectedTerminal?.name || "the terminal"}...`);
          } else if (status === "PROCESSING") {
            setTerminalMessage("Processing card payment. Please wait...");
          } else if (status === "SUCCESS") {
            clearInterval(pollingRef.current);
            setTerminalMessage("Payment approved! Finalizing invoice...");
            
            const updatedPayload = {
              ...payload,
              sales_invoice: {
                ...payload.sales_invoice,
                pay_method: "bank",
                note: `${payload.sales_invoice.note || ""} (Terminal Ref: ${response.payment_reference})`.trim()
              }
            };
            
            Post("createSalesInvoice", updatedPayload)
              .then((invoiceRes) => {
                handleToast({ type: "SUCCESS", message: "Invoice billed successfully via Terminal!" });
                if (openModal) {
                  setModalData(invoiceRes.data);
                  setShowInvoice(true);
                }
                resetInvoiceFields();
              })
              .catch((err) => {
                handleToast({ type: "ERROR", message: "Failed to finalize invoice database record." });
              })
              .finally(() => {
                setShowTerminalModal(false);
              });
          }
        })
        .catch((err) => {
          console.error("Error checking terminal status:", err);
        });
    }, 3000);
  };

  const resetInvoiceFields = () => {
    setFormData({
      store: storeId,
      date: new Date().toISOString().split("T")[0],
      customer: "",
      invoice_no: "",
      pay_method: "cash",
      additional_discount_value: "0",
      cheque_no: "",
      bank: "",
      note: "",
      total: "",
      round_off: "0",
    });
    setProducts([
      {
        store: storeId,
        barcode: "",
        additional_discount_value: "0",
        title: "",
        qty: 0,
        discount: 0,
        discount_percentage: 0,
        selling_price: 0,
        uom: "",
        amount: 0,
        total: 0,
        sold_qty_stock: 0,
        product_inventory: "",
        roundOff: 0,
      },
    ]);
  };

  const handleSubmit = async (openModal = false) => {
    try {
      const payMethodMapping = {
        bank: "bank",
        cheque: "cheque",
        cash: "cash",
        terminal: "terminal"
      };

      if (!formData.invoice_no) {

        handleToast({
          type: 'ERROR',
          message: "Invoice number is required!"
        })
        return;
      }

      if (!formData.customer) {

        handleToast({
          type: 'ERROR',
          message: "Customer name is required!"
        })
        return;
      }

      if (!shiftData?.is_active) {
        // No point sending this to the backend just to get a "no active
        // shift" error back - catch it here and let the user start a shift
        // right from this popup, then continue with the same sale.
        setPendingSubmitOpenModal(openModal);
        setShowShiftRequiredModal(true);
        return;
      }

      for (const [index, product] of products.entries()) {
        const discountPercentage = parseFloat(product.discount_percentage) || 0;
        const amount = parseFloat(product.amount) || 0;
        const total = parseFloat(product.total) || 0;

        const discountAmount = (discountPercentage / 100) * amount;
        const afterDiscountPrice = amount - discountAmount;

        if (afterDiscountPrice < total) {

          handleToast({
            type: 'ERROR',
            message: `After discount price for product with ID ${product.product} cannot be less than the total purchase price.`
          })
          return;
        }
      }

      const { roundedValue, roundOff } = calculateRoundOff(
        totals.totalDiscounted
      );

      const formattedRoundOff = roundOffEnabled
        ? parseFloat(roundOff.toFixed(2))
        : 0.0;

      const finalPayableAmount = roundOffEnabled
        ? roundedValue
        : totals.totalDiscounted - additionalDiscount;

      const payableAmount = parseFloat(finalPayableAmount.toFixed(2)) || 0;

      const payload = {
        sales_invoice: {
          store: formData.store,
          customer: formData.customer,
          date: formData.date,
          invoice_no: formData.invoice_no,
          pay_method:
            payMethodMapping[formData.pay_method] || formData.pay_method,
          additional_discount_value: formData.additional_discount_value || "0",
          cheque_no: formData.cheque_no,
          bank: formData.bank,
          note: formData.note,
          round_off: formattedRoundOff.toFixed(2),
          payable_amount: payableAmount.toFixed(2),

          invoice_type: formData.invoice_type || "wholesale",
        },
        sales_invoice_products: products
          .filter((product) => product.product)
          .map((product) => ({
            store: formData.store,
            product: product.product,
            sold_qty_stock: product.qty || 0,
            discount_percentage: product.discount_percentage || 0,
            uom: product.uom || "",
            total_pc_in_uom: product.total_pc_in_uom || 1,
            amount: product.amount.toFixed(2),
            total: product.total.toFixed(2),
            selling_price: product.selling_price.toFixed(2),
            segment_id: product.segment_id || "",
            segment_barcode: product.segment_barcode || "",
          })),
        inventory_clearance_pattern: "FIFO",
      };
      if (formData.pay_method === "terminal") {
        if (!selectedTerminal) {
          handleToast({ type: "ERROR", message: "Please configure a payment terminal in Settings first." });
          return;
        }
        setShowTerminalModal(true);
        setTerminalStatus("CONNECTING");
        setTerminalMessage(`Connecting to ${selectedTerminal.name}...`);
        
        Post("paymentsTerminal", {
          store_id: storeId,
          terminal_id: selectedTerminal.id,
          amount_minor: Math.round(payableAmount * 100)
        })
          .then((response) => {
            const data = response.data;
            pollTerminalPayment(data.payment_id, payload, openModal);
          })
          .catch((err) => {
            console.error("Error initiating payment:", err);
            setTerminalStatus("FAILED");
            setTerminalMessage(err.response?.data?.detail || "Failed to initiate payment on terminal.");
          });
        return;
      }

      const response = await Post("createSalesInvoice", payload);

      if (response && response.data && response.data.error) {
        handleToast({
          type: 'ERROR',
          message: response.data.error || "Something went wrong. Please try again."
        });
        return;
      }
      if (response.data.error && response.data.minimum_total_price_should_be) {

        handleToast({
          type: 'ERROR',
          message: response?.data?.error || "Something went wrong. Please try again."
        });

        return;
      }

      if (formData.pay_method === "cash") {
        triggerCashDrawerPop();
      }

      handleToast({
        type: 'SUCCESS',
        message: 'Sales invoice created successfully!'
      })

      if (openModal) {
        setModalData(response.data);
        setShowInvoice(true);
      }

      fetchSalesInvoiceData();

      setFormData({
        store: storeId,
        date: new Date().toISOString().split("T")[0],
        customer: "",
        barcode: "",
        invoice_no: "",
        pay_method: "cash",
        additional_discount_value: "0",
        cheque_no: "",
        bank: "",
        note: "",
        total: "",
        round_off: "0",
      });

      setProducts([
        {
          title: "",
          qty: "",
          per: 0,
          selling_price: "",
          rate: 0,
          discount: 0,
          discount_percentage: 0,
          amount: 0,
          total: 0,
          uom: "",
          barcode: "",
          segment_barcode: "",
        segment_id: "",
        },
      ]);

      setAdditionalDiscount("0");
      setRoundOffAmount(0);
    } catch (error) {
      console.error("Error creating sales invoice: ", error);

      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;

        if (errorMessage.includes("Insufficient stock")) {

          handleToast({
            type: 'ERROR',
            message: errorMessage
          })
        } else if (
          errorMessage.includes(
            "After discount price cannot be less than the total purchase price"
          )
        ) {

          handleToast({
            type: 'ERROR',
            message: errorMessage
          })
          return;
        } else {

          handleToast({
            type: 'ERROR',
            message: errorMessage
          })
        }
      } else {

        handleToast({
          type: 'ERROR',
          message: "Failed to create sales invoice. Please try again."
        })
      }
    }
  };

  const handleStartShiftAndContinueSale = async () => {
    setStartingShiftForSale(true);
    try {
      const result = await startShift();
      if (result?.success) {
        setShowShiftRequiredModal(false);
        handleToast({ type: "SUCCESS", message: "Shift started." });
        // Re-run the same sale now that a shift is active.
        handleSubmit(pendingSubmitOpenModal);
      } else {
        handleToast({ type: "ERROR", message: result?.error || "Could not start shift. Please try again." });
      }
    } catch (err) {
      console.error("Error starting shift from sale:", err);
      handleToast({ type: "ERROR", message: "Could not start shift. Please try again." });
    } finally {
      setStartingShiftForSale(false);
    }
  };

  const handleDeleteProduct = async (invoiceId) => {

    const result = await confirmDelete()

    if (!result.isConfirmed) return;

    try {

      const response = await Delete("salesInvoiceData", invoiceId);

      setSalesInvoiceData((prevData) =>
        prevData.filter((invoice) => invoice.id !== invoiceId)
      );

      handleToast({
        type: "SUCCESS",
        message: "Sales invoice deleted successfully!"
      })
    } catch (error) {
      console.error("Error deleting sales invoice: ", error);

      handleToast({
        type: "ERROR",
        message: "Failed to delete sales invoice. Please try again."
      })
    }
  };

  const handlePrint = async (invoiceId, openModal = false) => {
    try {

      const response = await Post("getSalesInvoiceDetails", {
        invoice_id: invoiceId,
      });

      if (response?.data && openModal) {
        setModalData(response.data);
        setShowInvoice(true);
      } else {
        console.error("Invalid API response:", response);
      }
    } catch (error) {
      console.error("Error fetching invoice details:", error);
    }
  };

  return (
    <div className="responsive-box winv-page">
      <ToastContainer />

      <style>
        {`
          .winv-page {
            min-height: 100vh;
            background:
              radial-gradient(circle at top left, rgba(79, 70, 229, 0.09), transparent 30%),
              radial-gradient(circle at top right, rgba(14, 116, 144, 0.08), transparent 28%),
              linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
            padding: 10px 12px 28px;
            color: #0f172a;
          }

          .winv-shell {
            max-width: 1280px;
            margin: 0 auto;
          }

          .winv-hero {
            background: linear-gradient(135deg, #020617 0%, #111827 55%, #3730a3 100%);
            color: #ffffff;
            border-radius: 24px;
            padding: 18px 20px;
            box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 18px;
            flex-wrap: wrap;
            margin-bottom: 14px;
            position: relative;
            overflow: hidden;
          }

          .winv-hero::after {
            content: "";
            position: absolute;
            width: 240px;
            height: 240px;
            border-radius: 999px;
            right: -90px;
            top: -130px;
            background: rgba(129, 140, 248, 0.16);
          }

          .winv-hero-content,
          .winv-hero-stats {
            position: relative;
            z-index: 1;
          }

          .winv-kicker {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            background: rgba(255, 255, 255, 0.13);
            border: 1px solid rgba(255, 255, 255, 0.22);
            color: #e0e7ff;
            padding: 6px 11px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 950;
            margin-bottom: 8px;
          }

          .winv-kicker-dot {
            width: 7px;
            height: 7px;
            border-radius: 999px;
            background: #a5b4fc;
            box-shadow: 0 0 0 4px rgba(165, 180, 252, 0.18);
          }

          .winv-title {
            margin: 0;
            font-size: 27px;
            font-weight: 950;
            letter-spacing: -0.04em;
            line-height: 1.1;
          }

          .winv-subtitle {
            margin: 6px 0 0;
            color: rgba(255, 255, 255, 0.78);
            font-size: 12px;
            font-weight: 700;
          }

          .winv-hero-stats {
            display: flex;
            gap: 10px;
            flex-wrap: wrap;
          }

          .winv-stat-card {
            min-width: 132px;
            background: rgba(255, 255, 255, 0.12);
            border: 1px solid rgba(255, 255, 255, 0.22);
            border-radius: 18px;
            padding: 11px 13px;
            backdrop-filter: blur(10px);
          }

          .winv-stat-label {
            font-size: 10px;
            font-weight: 900;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            color: rgba(255, 255, 255, 0.66);
          }

          .winv-stat-value {
            margin-top: 4px;
            font-size: 18px;
            font-weight: 950;
            color: #ffffff;
          }

          .winv-top-panel {
            background: rgba(255, 255, 255, 0.95);
            border: 1px solid #dbe3ec;
            border-radius: 22px;
            padding: 15px;
            box-shadow: 0 14px 36px rgba(15, 23, 42, 0.07);
            margin-bottom: 14px;
          }

          .winv-field-grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 12px;
          }

          .winv-field-card {
            border: 1px solid #dbe3ec;
            background: #ffffff;
            border-radius: 18px;
            padding: 12px;
            display: flex;
            align-items: center;
            gap: 11px;
            min-width: 0;
          }

          .winv-field-icon {
            width: 40px;
            height: 40px;
            border-radius: 14px;
            background: #eef2ff;
            border: 1px solid #c7d2fe;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          }

          .winv-field-icon img {
            width: 22px;
            height: 22px;
            object-fit: contain;
          }

          .winv-field-body {
            min-width: 0;
            flex: 1;
          }

          .winv-label {
            display: block;
            margin-bottom: 6px;
            color: #475569;
            font-size: 11px;
            font-weight: 950;
            text-transform: uppercase;
            letter-spacing: 0.04em;
          }

          .winv-input,
          .winv-page .form-control-invoice {
            width: 100% !important;
            height: 39px !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 13px !important;
            background: #ffffff !important;
            color: #0f172a !important;
            font-size: 13px !important;
            font-weight: 800 !important;
            padding: 0 12px !important;
            outline: none !important;
            box-shadow: none !important;
            transition: border 0.18s ease, box-shadow 0.18s ease;
          }

          .winv-input:focus,
          .winv-page .form-control-invoice:focus {
            border-color: #4f46e5 !important;
            box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.12) !important;
          }

          .winv-readonly {
            background: #f8fafc !important;
            color: #334155 !important;
          }

          .winv-billing-card {
            background: #ffffff;
            border: 1px solid #dbe3ec;
            border-radius: 24px;
            box-shadow: 0 16px 42px rgba(15, 23, 42, 0.075);
            overflow: visible;
            position: relative;
            z-index: 20;
          }

          .winv-card-header {
            padding: 15px 16px;
            border-bottom: 1px solid #e2e8f0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            flex-wrap: wrap;
          }

          .winv-section-title {
            margin: 0;
            color: #0f172a;
            font-size: 18px;
            font-weight: 950;
            letter-spacing: -0.025em;
          }

          .winv-section-subtitle {
            margin: 3px 0 0;
            color: #64748b;
            font-size: 12px;
            font-weight: 750;
          }

          .winv-badge {
            border-radius: 999px;
            padding: 7px 10px;
            background: #eef2ff;
            border: 1px solid #c7d2fe;
            color: #3730a3;
            font-size: 11px;
            font-weight: 950;
            white-space: nowrap;
          }

          .winv-table-wrap {
            overflow: visible;
            padding: 0 12px 18px;
            position: relative;
            z-index: 21;
          }

          .winv-table {
            width: 100%;
            min-width: 1080px;
            border-collapse: separate;
            border-spacing: 0 8px;
            position: relative;
            z-index: 22;
          }

          .winv-product-row.winv-row-focused {
            position: relative;
            z-index: 500;
          }

          .winv-table thead th {
            padding: 12px 10px;
            color: #475569;
            font-size: 11px;
            font-weight: 950;
            text-transform: uppercase;
            letter-spacing: 0.055em;
            background: #f8fafc;
            border-top: 1px solid #e2e8f0;
            border-bottom: 1px solid #e2e8f0;
            text-align: center;
          }

          .winv-table thead th:first-child {
            border-left: 1px solid #e2e8f0;
            border-radius: 14px 0 0 14px;
          }

          .winv-table thead th:last-child {
            border-right: 1px solid #e2e8f0;
            border-radius: 0 14px 14px 0;
          }

          .winv-table tbody tr.winv-product-row {
            position: relative;
            background: #ffffff;
            box-shadow: 0 7px 20px rgba(15, 23, 42, 0.055);
            transition: transform 0.16s ease, box-shadow 0.16s ease;
          }

          .winv-table tbody tr.winv-product-row:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 26px rgba(15, 23, 42, 0.10);
          }

          .winv-table tbody td {
            padding: 9px 8px;
            border-top: 1px solid #e2e8f0;
            border-bottom: 1px solid #e2e8f0;
            text-align: center;
            vertical-align: middle;
            position: relative;
          }

          .winv-table tbody td:first-child {
            border-left: 1px solid #e2e8f0;
            border-radius: 15px 0 0 15px;
          }

          .winv-table tbody td:last-child {
            border-right: 1px solid #e2e8f0;
            border-radius: 0 15px 15px 0;
          }

          .winv-sr-pill {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 12px;
            background: #eef2ff;
            color: #3730a3;
            font-size: 12px;
            font-weight: 950;
          }

          .winv-cell-input,
          .winv-page .field {
            width: 100%;
            min-width: 86px;
            height: 36px;
            border: 1px solid #dbe3ec !important;
            border-radius: 12px;
            background: #ffffff !important;
            color: #0f172a !important;
            font-size: 13px;
            font-weight: 850;
            text-align: center;
            outline: none;
            padding: 0 10px;
            transition: border 0.18s ease, box-shadow 0.18s ease;
          }

          .winv-cell-input:focus,
          .winv-page .field:focus,
          .winv-page .form-control-borderless:focus {
            border-color: #4f46e5 !important;
            box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.11);
          }

          .winv-product-search-cell {
            position: relative;
            min-width: 230px;
          }

          .winv-uom-select {
            width: 190px;
            height: 36px;
            border: 1px solid #dbe3ec;
            border-radius: 12px;
            background: #ffffff;
            color: #0f172a;
            font-size: 12px;
            font-weight: 800;
            text-align: center;
            outline: none;
            padding: 0 8px;
          }

          .winv-search-results {
            position: fixed;
            max-height: 340px;
            overflow-y: auto;
            list-style: none;
            margin: 0;
            padding: 7px;
            border-radius: 18px;
            background: #ffffff;
            border: 1px solid #cbd5e1;
            box-shadow: 0 32px 80px rgba(15, 23, 42, 0.30), 0 0 0 4px rgba(255, 255, 255, 0.88);
            z-index: 2147483000;
            overscroll-behavior: contain;
          }

          .winv-search-results::-webkit-scrollbar {
            width: 8px;
          }

          .winv-search-results::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 999px;
          }

          .winv-search-results::-webkit-scrollbar-track {
            background: #f8fafc;
            border-radius: 999px;
          }

          .winv-search-item {
            padding: 10px 11px;
            border-radius: 12px;
            cursor: pointer;
            color: #0f172a;
            font-size: 13px;
            font-weight: 850;
            text-align: left;
            transition: background 0.16s ease, transform 0.16s ease;
          }

          .winv-search-item:hover {
            background: #eef2ff;
            transform: translateX(2px);
          }

          .winv-search-sub {
            font-size: 11px;
            color: #64748b;
            margin-top: 3px;
            font-weight: 750;
          }

          .winv-search-empty {
            position: fixed;
            padding: 12px;
            border-radius: 18px;
            background: #ffffff;
            border: 1px solid #cbd5e1;
            box-shadow: 0 32px 80px rgba(15, 23, 42, 0.30), 0 0 0 4px rgba(255, 255, 255, 0.88);
            z-index: 2147483000;
            color: #64748b;
            font-size: 12px;
            font-weight: 800;
            text-align: center;
          }

          .winv-money-cell {
            min-width: 125px;
            font-size: 14px;
            font-weight: 950;
            color: #3730a3;
            background: #eef2ff;
          }

          .winv-total-cell {
            min-width: 135px;
            font-size: 14px;
            font-weight: 950;
            color: #064e3b;
            background: #f0fdf4;
          }

          .winv-delete-btn {
            width: 31px;
            height: 31px;
            border: none;
            border-radius: 11px;
            background: #fee2e2;
            color: #991b1b;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-left: 8px;
            transition: transform 0.16s ease, background 0.16s ease;
          }

          .winv-delete-btn:hover {
            transform: scale(1.05);
            background: #fecaca;
          }

          .winv-total-row td {
            background: #fffbeb !important;
            border-color: #fde68a !important;
            font-size: 13px;
            font-weight: 950;
            color: #78350f;
          }

          .winv-bottom-grid {
            display: grid;
            grid-template-columns: 1.1fr 0.9fr;
            gap: 14px;
            margin-top: 14px;
            align-items: start;
            position: relative;
            z-index: 5;
          }

          .winv-panel {
            background: #ffffff;
            border: 1px solid #dbe3ec;
            border-radius: 22px;
            padding: 15px;
            box-shadow: 0 14px 36px rgba(15, 23, 42, 0.065);
          }

          .winv-payment-options {
            display: flex;
            gap: 8px;
            flex-wrap: wrap;
            padding: 5px;
            border: 1px solid #dbe3ec;
            border-radius: 999px;
            width: fit-content;
            background: #f8fafc;
          }

          .winv-payment-chip {
            border: none;
            border-radius: 999px;
            padding: 9px 14px;
            background: transparent;
            color: #334155;
            font-size: 12px;
            font-weight: 950;
            cursor: pointer;
            transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;
          }

          .winv-payment-chip:hover {
            transform: translateY(-1px);
          }

          .winv-payment-chip.active {
            background: #3730a3;
            color: #ffffff;
            box-shadow: 0 8px 18px rgba(55, 48, 163, 0.18);
          }

          .winv-note {
            width: 100%;
            min-height: 86px;
            resize: vertical;
            border: 1px solid #dbe3ec;
            border-radius: 16px;
            background: #ffffff;
            color: #334155;
            padding: 11px 12px;
            font-size: 13px;
            font-weight: 750;
            outline: none;
          }

          .winv-summary-panel {
            background: radial-gradient(circle at top right, rgba(79, 70, 229, 0.10), transparent 38%), #ffffff;
            border: 1px solid #c7d2fe;
          }

          .winv-roundoff-row,
          .winv-discount-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            margin-bottom: 13px;
          }

          .winv-roundoff-toggle {
            display: inline-flex;
            border: 1px solid #cbd5e1;
            border-radius: 999px;
            padding: 4px;
            background: #ffffff;
          }

          .winv-toggle-option {
            min-width: 58px;
            border-radius: 999px;
            padding: 7px 12px;
            text-align: center;
            cursor: pointer;
            color: #334155;
            font-size: 12px;
            font-weight: 950;
          }

          .winv-toggle-option.active {
            background: #3730a3;
            color: #ffffff;
          }

          .winv-discount-input {
            width: 140px;
            height: 36px;
            border: 1px solid #cbd5e1;
            border-radius: 12px;
            text-align: center;
            color: #0f172a;
            font-size: 13px;
            font-weight: 850;
            outline: none;
          }

          .winv-summary-line {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            padding: 9px 0;
            border-bottom: 1px dashed #cbd5e1;
            color: #334155;
            font-size: 13px;
            font-weight: 850;
          }

          .winv-summary-line strong {
            color: #0f172a;
            font-size: 14px;
            font-weight: 950;
          }

          .winv-payable-box {
            margin-top: 14px;
            border-radius: 20px;
            padding: 16px;
            background: linear-gradient(135deg, #312e81 0%, #3730a3 100%);
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
          }

          .winv-payable-label {
            font-size: 12px;
            font-weight: 900;
            color: rgba(255, 255, 255, 0.76);
            text-transform: uppercase;
            letter-spacing: 0.06em;
          }

          .winv-payable-value {
            font-size: 26px;
            font-weight: 950;
            letter-spacing: -0.04em;
          }

          .winv-actions {
            display: flex;
            justify-content: flex-end;
            gap: 11px;
            margin-top: 14px;
            flex-wrap: wrap;
          }

          .winv-btn {
            border: none;
            border-radius: 999px;
            min-width: 155px;
            height: 45px;
            padding: 0 18px;
            font-size: 13px;
            font-weight: 950;
            cursor: pointer;
            transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
          }

          .winv-btn:hover {
            transform: translateY(-1px);
          }

          .winv-btn-clear {
            background: #ffffff;
            color: #0f172a;
            border: 1px solid #94a3b8;
          }

          .winv-btn-primary {
            background: #3730a3;
            color: #ffffff;
            box-shadow: 0 12px 24px rgba(55, 48, 163, 0.20);
          }

          .winv-btn-dark {
            background: #0f172a;
            color: #ffffff;
            box-shadow: 0 12px 24px rgba(15, 23, 42, 0.18);
          }

          @media (max-width: 1100px) {
            .winv-table-wrap {
              overflow-x: auto;
              overflow-y: visible;
              padding-bottom: 80px;
            }

            .winv-field-grid {
              grid-template-columns: 1fr;
            }

            .winv-bottom-grid {
              grid-template-columns: 1fr;
            }

            .winv-hero-stats {
              width: 100%;
            }

            .winv-stat-card {
              flex: 1;
              min-width: 0;
            }
          }

          @media (max-width: 640px) {
            .winv-page {
              padding: 8px 8px 22px;
            }

            .winv-hero {
              border-radius: 20px;
              padding: 16px;
            }

            .winv-title {
              font-size: 23px;
            }

            .winv-payment-options {
              width: 100%;
              border-radius: 18px;
            }

            .winv-payment-chip {
              flex: 1;
            }

            .winv-actions {
              flex-direction: column;
            }

            .winv-btn {
              width: 100%;
            }

            .winv-payable-box {
              flex-direction: column;
              align-items: flex-start;
            }
          }
        `}
      </style>

      {showShiftRequiredModal && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: "16px",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              padding: "28px",
              maxWidth: "420px",
              width: "100%",
              textAlign: "center",
              boxShadow: "0 24px 60px rgba(15, 23, 42, 0.25)",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                background: "#eefbf2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                fontSize: "26px",
              }}
            >
              🕒
            </div>
            <h3 style={{ margin: "0 0 8px", fontSize: "18px", fontWeight: 850, color: "#0f172a" }}>
              Start a shift to make this sale
            </h3>
            <p style={{ margin: "0 0 22px", fontSize: "14px", color: "#64748b" }}>
              Sales can only be recorded while a shift is active. Start one now and this sale will go through right after.
            </p>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
              <button
                type="button"
                onClick={() => setShowShiftRequiredModal(false)}
                disabled={startingShiftForSale}
                style={{
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  background: "#fff",
                  color: "#334155",
                  fontWeight: 700,
                  cursor: startingShiftForSale ? "not-allowed" : "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleStartShiftAndContinueSale}
                disabled={startingShiftForSale}
                style={{
                  padding: "10px 24px",
                  borderRadius: "10px",
                  border: "none",
                  background: startingShiftForSale ? "#94a3b8" : "#16a34a",
                  color: "#fff",
                  fontWeight: 800,
                  cursor: startingShiftForSale ? "not-allowed" : "pointer",
                }}
              >
                {startingShiftForSale ? "Starting Shift..." : "Start Shift & Sell"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="winv-shell">
        <div className="winv-hero">
          <div className="winv-hero-content">
            <div className="winv-kicker">
              <span className="winv-kicker-dot" />
              <span>Wholesale Billing</span>
            </div>
            <h1 className="winv-title">Wholesale Invoice</h1>
            <p className="winv-subtitle">
              Create wholesale invoices with customer, UOM, discounts and payment details.
            </p>
          </div>

          <div className="winv-hero-stats">
            <div className="winv-stat-card">
              <div className="winv-stat-label">Items</div>
              <div className="winv-stat-value">{totalQty || 0}</div>
            </div>
            <div className="winv-stat-card">
              <div className="winv-stat-label">Subtotal</div>
              <div className="winv-stat-value">{formatCurrency(Number(totalAmount || 0))}</div>
            </div>
            <div className="winv-stat-card">
              <div className="winv-stat-label">Payable</div>
              <div className="winv-stat-value">
                {formatCurrency(typeof finalPayableAmount === "number" && !isNaN(finalPayableAmount)
                  ? finalPayableAmount
                  : 0)}
              </div>
            </div>
          </div>
        </div>

        <div className="winv-top-panel">
          <div className="winv-field-grid">
            <div className="winv-field-card">
              <div className="winv-field-icon">
                <span style={{ fontSize: "19px", fontWeight: 950, color: "#3730a3" }}>D</span>
              </div>
              <div className="winv-field-body">
                <label className="winv-label">Invoice Date</label>
                <CustomDateInput
                  value={formData.date}
                  onChange={handleFormChange}
                  required
                  readOnly
                  className="form-control-invoice"
                  inputStyle={{ height: "39px" }}
                  showIcon={true}
                  iconStyle={{ fontSize: "18px", color: "#3730a3" }}
                  style={{ width: "100%" }}
                />
              </div>
            </div>

            <div className="winv-field-card">
              <div className="winv-field-icon">
                <img src={User} alt="User Icon" />
              </div>
              <div className="winv-field-body">
                <label className="winv-label">Customer Name</label>
                <input
                  type="text"
                  id="customerName"
                  name="customer_name"
                  value={formData.customer}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[a-zA-Z\s]*$/.test(value) || value === "") {
                      setFormData((prevState) => ({
                        ...prevState,
                        customer: capitalizeFirstLetter(value),
                      }));
                    }
                  }}
                  className="winv-input"
                  placeholder="Enter customer name"
                />
              </div>
            </div>

            <div className="winv-field-card">
              <div className="winv-field-icon">
                <img src={Invoice} alt="Invoice Icon" />
              </div>
              <div className="winv-field-body">
                <label className="winv-label">Invoice Number</label>
                <input
                  type="text"
                  id="invoiceNo"
                  name="invoice_no"
                  className="winv-input winv-readonly"
                  readOnly
                  value={formData.invoice_no}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 20) {
                      handleFormChange(e);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="winv-billing-card">
          <div className="winv-card-header">
            <div>
              <h2 className="winv-section-title">Wholesale Product Billing</h2>
              <p className="winv-section-subtitle">
                Add products by barcode or search, then select UOM and discount.
              </p>
            </div>
            <span className="winv-badge">
              {products.filter((product) => product.product).length} Products Added
            </span>
          </div>

          <div className="winv-table-wrap">
            <table className="winv-table">
              <thead>
                <tr>
                  <th style={{ width: "68px" }}>Sr.</th>
                  <th style={{ width: "150px" }}>Barcode</th>
                  <th style={{ width: "250px" }}>Product Name</th>
                  <th>Quantity</th>
                  <th>Rate</th>
                  <th>UOM</th>
                  <th>Amount</th>
                  <th>Discount (%)</th>
                  <th>Total</th>
                </tr>
              </thead>

              <tbody>
                {products.map((product, index) => (
                  <tr
                    className={`winv-product-row ${focusedIndex === index ? "winv-row-focused" : ""}`}
                    key={index}
                  >
                    <td>
                      <span className="winv-sr-pill">{index + 1}</span>
                    </td>

                    <td>
                      <input
                        type="text"
                        className="winv-cell-input"
                        placeholder="Barcode"
                        value={product.barcode || product.segment_barcode || ""}
                        onChange={(e) =>
                          handleInputChange(index, "barcode", e.target.value)
                        }
                        onBlur={() => handleBarcodeBlur(index)}
                      />
                    </td>

                    <td className="winv-product-search-cell">
                      <input
                        type="text"
                        placeholder="Search product"
                        className="winv-cell-input"
                        value={focusedIndex === index ? searchQuery : products[index].title}
                        onChange={(e) => handleSearch(index, e.target.value, e.target)}
                        onFocus={(e) => {
                          setFocusedIndex(index);
                          setSearchQuery("");
                          setIsSearching(false);
                          setSearchResults(productInventory);
                          updateFloatingDropdownPosition(e.target);
                        }}
                        onBlur={() => {
                          setTimeout(() => {
                            if (dropdownInteractingRef.current) return;

                            if (focusedIndex === index) {
                              setFocusedIndex(null);
                              setSearchResults([]);
                              setSearchQuery("");
                              setIsSearching(false);
                              closeFloatingDropdown();
                            }
                          }, 220);
                        }}
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        placeholder="Qty"
                        className="winv-cell-input"
                        value={product.qty}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value >= 0 && value.length <= 4) {
                            handleInputChange(index, "qty", value);
                          }
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 4);
                        }}
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        placeholder="Rate"
                        className="winv-cell-input"
                        value={products[index].selling_price || ""}
                        onChange={(e) =>
                          handleInputChange(index, "selling_price", e.target.value)
                        }
                      />
                    </td>

                    <td>
                      {products[index].product ? (
                        <select
                          className="winv-uom-select"
                          value={products[index].segment_id || products[index].uom}
                          onChange={(e) => {
                            const selectedSegmentId = e.target.value;
                            const selectedProduct = getProductFromCacheOrInventory(products[index].product);
                            const selectedSegment = selectedProduct?.segments?.find(
                              (segment) => segment.id === selectedSegmentId
                            );

                            handleUomChange(
                              index,
                              selectedSegment?.uom || "",
                              selectedSegmentId
                            );
                          }}
                        >
                          <option value="" disabled>
                            Select UOM
                          </option>
                          {(() => {
                            let productData = productInventory.find((item) => item.id === products[index].product);

                            if (!productData) {
                              productData = productDetailsCache[products[index].product];
                            }

                            if (productData && productData.segments && productData.segments.length > 0) {
                              return getAvailableSegments(productData).map((segment) => (
                                <option key={segment.id} value={segment.id}>
                                  {segment.uom_title} - {segment.total_pc_in_uom} pcs - {formatCurrency(Number(segment.selling_price || 0))}
                                </option>
                              ));
                            }

                            return (
                              <option key="no-uom" value="" disabled>
                                No UOMs available
                              </option>
                            );
                          })()}
                        </select>
                      ) : (
                        <span style={{ color: "#94a3b8", fontWeight: 850 }}>UOM</span>
                      )}
                    </td>

                    <td className="winv-money-cell">
                      {formatCurrency(Number(product.amount || 0))}
                    </td>

                    <td>
                      <input
                        type="text"
                        placeholder="Discount"
                        className="winv-cell-input"
                        value={product.discount}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value >= 0 && value.length <= 4) {
                            handleInputChange(index, "discount", value);
                          }
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.slice(0, 4);
                        }}
                      />
                    </td>

                    <td className="winv-total-cell">
                      {formatCurrency(Number(product.total || 0))}
                      {index !== products.length - 1 && (
                        <button
                          type="button"
                          aria-label="Delete product"
                          onClick={() => handleDeleteRow(index)}
                          className="winv-delete-btn"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.00016 12.6667C4.00016 13.4 4.60016 14 5.3335 14H10.6668C11.4002 14 12.0002 13.4 12.0002 12.6667V6C12.0002 5.26667 11.4002 4.66667 10.6668 4.66667H5.3335C4.60016 4.66667 4.00016 5.26667 4.00016 6V12.6667ZM12.0002 2.66667H10.3335L9.86016 2.19333C9.74016 2.07333 9.56683 2 9.3935 2H6.60683C6.4335 2 6.26016 2.07333 6.14016 2.19333L5.66683 2.66667H4.00016C3.6335 2.66667 3.3335 2.96667 3.3335 3.33333C3.3335 3.7 3.6335 4 4.00016 4H12.0002C12.3668 4 12.6668 3.7 12.6668 3.33333C12.6668 2.96667 12.3668 2.66667 12.0002 2.66667Z"
                              fill="currentColor"
                            />
                          </svg>
                        </button>
                      )}
                    </td>
                  </tr>
                ))}

                <tr className="winv-total-row">
                  <td colSpan="3" style={{ textAlign: "right" }}>
                    Total Values
                  </td>
                  <td>{totalQty}</td>
                  <td>{Number(totalRate || 0).toFixed(2)}</td>
                  <td>{uniquePer.join(", ")}</td>
                  <td>{formatCurrency(Number(totalAmount || 0))}</td>
                  <td>{Number(totalDiscount || 0).toFixed(2)}</td>
                  <td>{formatCurrency(Number(totalDiscounted || 0))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="winv-bottom-grid">
          <div className="winv-panel">
            <h2 className="winv-section-title">Payment Details</h2>
            <p className="winv-section-subtitle" style={{ marginBottom: "12px" }}>
              Select payment mode and add invoice note.
            </p>

            <div style={{ marginBottom: "14px" }}>
              <label className="winv-label">Payment Method</label>
              <div className="winv-payment-options">
                {["bank", "cash", "cheque", "terminal"].map((method) => (
                  <button
                    type="button"
                    key={method}
                    className={`winv-payment-chip ${formData.pay_method === method ? "active" : ""}`}
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, pay_method: method }))
                    }
                  >
                    {method === "bank"
                      ? "Bank Card"
                      : method === "terminal"
                      ? "Terminal"
                      : method.charAt(0).toUpperCase() + method.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            {formData.pay_method === "terminal" && (
              <div style={{ marginBottom: "14px", display: "flex", flexDirection: "column", gap: "6px" }}>
                <label className="winv-label">Select Terminal</label>
                {terminals.length > 0 ? (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    {selectedTerminal && (
                      <img 
                        src={
                          selectedTerminal.provider === "CLOVER" ? "https://cloverstatic.com/web/apps/cloverdotcom/release::v2.142.0-f81e9288a386b/assets/media/clover-logo.5637c88fda21055b797e300e16140c95.svg" :
                          selectedTerminal.provider === "STRIPE" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/330px-Stripe_Logo%2C_revised_2016.svg.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail" :
                          selectedTerminal.provider === "SQUARE" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Square%2C_Inc._logo.svg/3840px-Square%2C_Inc._logo.svg.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail" :
                          selectedTerminal.provider === "ADYEN" ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLwbTNAl15w8i2X2hvS1FQlVFTRuJbEAoi_m2aUJwGJ1RhL18li_Po4fQ&s=10" :
                          selectedTerminal.provider === "PINE_LABS" ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSWMtmHPJkKFRxPBaCiw49vdQNLgBaxtG9Ls2hwYr2LY2RXP0KkMsG9WcJ&s=10" :
                          selectedTerminal.provider === "PAYTM" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Paytm_Logo_%28standalone%29.svg/1280px-Paytm_Logo_%28standalone%29.svg.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail" : ""
                        } 
                        alt={selectedTerminal.provider} 
                        style={{ height: '24px', maxWidth: '80px', objectFit: 'contain' }} 
                      />
                    )}
                    <select
                      value={selectedTerminal?.id || ""}
                      onChange={(e) => {
                        const found = terminals.find(t => t.id === e.target.value);
                        setSelectedTerminal(found);
                      }}
                      style={{
                        padding: '10px 14px',
                        borderRadius: '12px',
                        border: '1px solid #cbd5e1',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        background: '#ffffff',
                        color: '#0f172a',
                        outline: 'none',
                        minWidth: '220px'
                      }}
                    >
                      {terminals.map(t => (
                        <option key={t.id} value={t.id}>{t.name} ({t.provider})</option>
                      ))}
                    </select>
                  </div>
                ) : (
                  <span style={{ fontSize: '13px', color: '#dc2626', fontWeight: 'bold' }}>
                    No active terminals. Please configure a terminal in Settings.
                  </span>
                )}
              </div>
            )}

            <div>
              <label htmlFor="note" className="winv-label">
                Note
              </label>
              <textarea
                id="note"
                rows="4"
                value={formData.note}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, note: e.target.value }))
                }
                placeholder="Type here..."
                className="winv-note"
              />
            </div>
          </div>

          <div className="winv-panel winv-summary-panel">
            <h2 className="winv-section-title">Invoice Summary</h2>
            <p className="winv-section-subtitle" style={{ marginBottom: "12px" }}>
              Final amount after discounts and round-off.
            </p>

            <div className="winv-discount-row">
              <span className="winv-label" style={{ marginBottom: 0 }}>
                Additional Discount
              </span>
              <input
                type="text"
                className="winv-discount-input"
                placeholder="0.00"
                value={additionalDiscount}
                onChange={(e) => handleAdditionalDiscountChange(e)}
              />
            </div>

            <div className="winv-roundoff-row">
              <span className="winv-label" style={{ marginBottom: 0 }}>
                Round Off
              </span>
              <div className="winv-roundoff-toggle">
                <label className={`winv-toggle-option ${roundOffEnabled ? "active" : ""}`}>
                  <input
                    type="radio"
                    value="yes"
                    checked={roundOffEnabled}
                    onChange={handleRoundOffChange}
                    style={{ display: "none" }}
                  />
                  Yes
                </label>
                <label className={`winv-toggle-option ${!roundOffEnabled ? "active" : ""}`}>
                  <input
                    type="radio"
                    value="no"
                    checked={!roundOffEnabled}
                    onChange={handleRoundOffChange}
                    style={{ display: "none" }}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="winv-summary-line">
              <span>Total Quantity</span>
              <strong>{totalQty || 0}</strong>
            </div>
            <div className="winv-summary-line">
              <span>Total Amount</span>
              <strong>{formatCurrency(Number(totalAmount || 0))}</strong>
            </div>
            <div className="winv-summary-line">
              <span>Discounted Total</span>
              <strong>{formatCurrency(Number(totalDiscounted || 0))}</strong>
            </div>
            <div className="winv-summary-line">
              <span>Round Off</span>
              <strong>{formatCurrency(roundOffEnabled ? Number(roundOff || 0) : 0)}</strong>
            </div>

            <div className="winv-payable-box">
              <div>
                <div className="winv-payable-label">Payable Amount</div>
                <div className="winv-section-subtitle" style={{ color: "rgba(255,255,255,0.70)" }}>
                  Ready for billing
                </div>
              </div>
              <div className="winv-payable-value">
                {formatCurrency(typeof finalPayableAmount === "number" && !isNaN(finalPayableAmount)
                  ? finalPayableAmount
                  : 0)}
              </div>
            </div>
          </div>
        </div>

        <div className="winv-actions">
          <button
            type="button"
            className="winv-btn winv-btn-clear"
            onClick={handleCancel}
          >
            Clear
          </button>

          <button
            type="button"
            className="winv-btn winv-btn-primary"
            onClick={() => handleSubmit(true)}
          >
            Save & Print
          </button>

          <button
            type="button"
            onClick={() => handleSubmit(false)}
            className="winv-btn winv-btn-dark"
          >
            Save
          </button>
        </div>

        {focusedIndex !== null && floatingDropdownStyle && (
          <>
            {searchResults.length > 0 ? (
              <ul
                className="winv-search-results"
                style={{
                  top: `${floatingDropdownStyle.top}px`,
                  left: `${floatingDropdownStyle.left}px`,
                  width: `${floatingDropdownStyle.width}px`,
                }}
                onMouseDownCapture={() => {
                  dropdownInteractingRef.current = true;
                }}
                onMouseUpCapture={() => {
                  setTimeout(() => {
                    dropdownInteractingRef.current = false;
                  }, 120);
                }}
                onMouseLeave={() => {
                  dropdownInteractingRef.current = false;
                }}
              >
                {searchResults
                  .filter(
                    (item) =>
                      item.segments &&
                      item.segments.some((segment) => segment.inventory_available)
                  )
                  .map((item) => {
                    const defaultSegment = getDefaultAvailableSegment(item);

                    return (
                      <li
                        key={item.id}
                        onMouseDown={(event) => {
                          event.preventDefault();
                          handleSelectProduct(focusedIndex, item);
                          closeFloatingDropdown();
                        }}
                        className="winv-search-item"
                      >
                        <div>{item.title}</div>
                        {defaultSegment && (
                          <div className="winv-search-sub">
                            Default: {defaultSegment.uom_title} • {formatCurrency(Number(defaultSegment.selling_price || 0))}
                          </div>
                        )}
                      </li>
                    );
                  })}
              </ul>
            ) : (
              !loading && (
                <div
                  className="winv-search-empty"
                  style={{
                    top: `${floatingDropdownStyle.top}px`,
                    left: `${floatingDropdownStyle.left}px`,
                    width: `${floatingDropdownStyle.width}px`,
                  }}
                >
                  No products found
                </div>
              )
            )}
          </>
        )}

        <SalesInvoicePrint
          open={showInvoice}
          onClose={handleCloseModal}
          data={modalData}
          onPrint={handlePrint}
        />

        {showTerminalModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div style={{
              background: '#ffffff',
              padding: '30px',
              borderRadius: '12px',
              width: '400px',
              textAlign: 'center',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>
                {terminalStatus === "CONNECTING" && "🔌"}
                {terminalStatus === "WAITING_FOR_CUSTOMER" && "💳"}
                {terminalStatus === "PROCESSING" && "🔄"}
                {terminalStatus === "SUCCESS" && "✅"}
                {terminalStatus === "FAILED" && "❌"}
              </div>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '20px', color: '#0f172a' }}>
                {terminalStatus === "CONNECTING" && "Connecting to Terminal"}
                {terminalStatus === "WAITING_FOR_CUSTOMER" && "Swipe / Tap / Insert Card"}
                {terminalStatus === "PROCESSING" && "Processing Payment"}
                {terminalStatus === "SUCCESS" && "Payment Successful"}
                {terminalStatus === "FAILED" && "Payment Failed"}
              </h3>
              <p style={{ color: '#475569', fontSize: '14px', margin: '0 0 20px 0', minHeight: '40px', lineHeight: '1.5' }}>
                {terminalMessage}
              </p>
              {terminalStatus === "WAITING_FOR_CUSTOMER" && selectedTerminal && (
                <div style={{ margin: '0 0 20px 0', padding: '10px', background: '#eff6ff', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
                  <a 
                    href={
                      selectedTerminal.provider === "CLOVER" ? "https://sandbox.dev.clover.com/" :
                      selectedTerminal.provider === "STRIPE" ? "https://stripe.com/docs/terminal/references/testing#simulated-reader" :
                      selectedTerminal.provider === "SQUARE" ? "https://developer.squareup.com/docs/terminal-api/testing" :
                      selectedTerminal.provider === "ADYEN" ? "https://docs.adyen.com/point-of-sale/testing-terminals" :
                      selectedTerminal.provider === "PINE_LABS" ? "https://developer.pinelabs.com/" :
                      selectedTerminal.provider === "PAYTM" ? "https://developer.paytm.com/docs/pos/" : "#"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontSize: '13px', color: '#1d4ed8', fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    👉 Open {selectedTerminal.provider} Simulator / Testing Docs
                  </a>
                </div>
              )}
              {terminalStatus === "FAILED" && (
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                  <button
                    onClick={() => handleSubmit(true)}
                    style={{
                      padding: '8px 16px',
                      background: '#0284c7',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '6px',
                      fontWeight: 'bold',
                      cursor: 'pointer'
                    }}
                  >
                    Try Again
                  </button>
                  <button
                    onClick={() => {
                      if (pollingRef.current) clearInterval(pollingRef.current);
                      setShowTerminalModal(false);
                    }}
                    style={{
                      padding: '8px 16px',
                      background: '#cbd5e1',
                      color: '#334155',
                      border: 'none',
                      borderRadius: '6px',
                      fontWeight: 'bold',
                      cursor: 'pointer'
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
              {terminalStatus !== "FAILED" && terminalStatus !== "SUCCESS" && (
                <button
                  onClick={() => {
                    if (pollingRef.current) clearInterval(pollingRef.current);
                    setShowTerminalModal(false);
                  }}
                  style={{
                    padding: '8px 16px',
                    background: '#cbd5e1',
                    color: '#334155',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 'bold',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );

}

export default SalesInvoice;